<template>
    <main>
        <a class="chat-button" @click="openmodalchat" :style="modalchat?'display:none':'display:block'"><i style="color:white" class="fas fa-comment"></i> <span class="campana" v-if="datanovisiblechat>0">{{datanovisiblechat}}</span></a>
        <v-dialog v-model="modalchat" fullscreen hide-overlay transition="dialog-bottom-transition" style="position:relative;z-index:10000000000">
            <v-card>
                <v-toolbar dark color="#007bff" fixed
                    
                    >
                    <v-btn icon dark @click="closemodalchat">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                    <v-toolbar-title>Chat</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="openhistorialchat">
                        <v-icon>fas fa-history</v-icon>
                        <span class="campana" v-if="datanovisiblechathistorial>0">{{datanovisiblechathistorial}}</span>
                    </v-btn>
                    
                </v-toolbar>
                <v-list class="div-list" style="padding-top:80px; padding-bottom:150px">
                    <div v-if="tabactivechat[1].active">
                        <div class="J-chat-container J-conversation">
                            <div class="J-chat-avatar-content">
                                <a href="javascript:void(0)"  class="J-icon-back" @click="openuseractivechat">
                                    <i class="fas fa-angle-left" style="font-size:30px"></i>
                                </a>
                                <v-avatar size="60px">
                                    <img :src="datauserchoosed.photo[0].link" alt="Avatar">
                                </v-avatar>
                                <div class="J-chat-message-content">
                                    <div class="J-chat-name">
                                        <span>
                                        {{datauserchoosed.fullname}}
                                        </span>
                                    </div>
                                    <div class="J-chat-date">
                                        <span>
                                           {{datauserchoosed.activedescription}}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="J-chat-convesation-content">
                                <div class="J-chat-conversation scrollmenucompany" id="messages_content">
                                    <div class="J-user-conversation" style="margin-top:20px" v-for="(message,index) in message_data" :key="index+1" :class="{'J-user-response':message._id_user._id==identity._id}">
                                        <div class="J-user-avatar" style="margin-top:3px">
                                            <v-avatar size="36px">
                                                <img :src="message._id_user.photo[0].link" alt="Avatar">
                                            </v-avatar>
                                            
                                                <v-btn v-if="message._id_user._id===identity._id" @click="deletemessagechoosed(message._id)" icon slot="activator" style="color:white; margin-top:18px">
                                                    <v-icon>fas fa-trash-alt</v-icon>
                                                </v-btn> 
                                                
                                                <v-btn v-if="message._id_user._id!==identity._id" icon slot="activator" @click="deletemessagechoosed(message._id)">
                                                    <v-icon>fas fa-trash-alt</v-icon>
                                                </v-btn>
                                                
                                            
                                        </div>
                                        <div class="J-chat-message">
                                            <p :style="message._id_user._id==identity._id?'color:white;margin-top:2px;margin-left:3px':'margin-top:10px;'">
                                               {{message.message}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="J-chat-response">
                                    <div class="J-chat-form">
                                        <form @submit.prevent="savenewmessage">
                                            <input required class="form-control J-chat-input" v-model="message"  :placeholder="language==='English'?'Message...':'Mensaje...'">
                                            <button class="btn J-chat-btn" type="submit">{{language==='English'?'Send':'Enviar'}}</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tabactivechat[0].active">
                        <div class="text-center" v-if="useractive.length<=0">
                            <label>{{language==='English'?'No users active':'No hay usuarios activos'}}</label>
                        </div>
                        <div  class="J-chat-container" v-for="useractive in useractive" :key="useractive.length" @click="openchatconversation(useractive._id)">
                            <div class="J-chat-avatar-content">
                                <v-avatar size="60px">
                                    <img alt="Avatar" :src="useractive.photo[0].link">
                                    <span class="campana" v-if="useractive.count>0">{{useractive.count}}</span>
                                </v-avatar>
                            </div>
                            <div class="J-chat-message-content">
                                <div class="J-chat-name">
                                    <span>
                                        {{useractive.fullname}}
                                    </span>
                                </div>
                                <div class="J-chat-date">
                                    <span>{{language==='English'?useractive.history[0].description==='active'?'Active now':'':useractive.history[0].description==='active'?'Activo ahora':''}}</span>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                    <div v-if="tabactivechat[2].active">
                        <div class="J-chat-avatar-content text-center">
                            <a href="javascript:void(0)"  class="J-icon-back" @click="openuseractivechat">
                                <i class="fas fa-angle-left" style="font-size:40px"></i>
                            </a>
                            <label style="font-size:30px;margin-left:20px;font-weight:bold">{{language==='English'?'My Chat History':'Mi Historial de Chat'}}</label>
                            
                        </div>
                        <div class="text-center" v-if="historialdata.length<=0">
                            <label>{{language==='English'?'no chat history':'no hay historial'}}</label>
                        </div>
                        <div class="J-chat-container" v-for="historialdata in historialdata" :key="historialdata.length" @click="seecontenthistorialchat(historialdata);openchatconversation(historialdata.historialdata._id_user._id)">
                            <div class="J-chat-avatar-content">
                                <v-avatar size="60px">
                                    <img :src="historialdata.historialdata._id_user.photo[0].link" alt="Avatar">
                                    <span class="campana" v-if="historialdata.count>0">{{historialdata.count}}</span>
                                </v-avatar>
                            </div>
                            <div class="J-chat-message-content">
                                <div class="J-chat-name">
                                    <span>
                                        {{historialdata.historialdata._id_user.fullname}}
                                    </span>
                                </div>
                                <div class="J-chat-message">
                                    <span>
                                       {{historialdata.historialdata.message}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-list>
            </v-card>
        </v-dialog>
    </main>
</template>
<script>
import { ChatsimpleService, HistorialchatService, UsersService } from "@/services";
import moment from 'moment';
import { EventBus } from '../../../helpers/eventbus/event-bus';


export default {
    data(){
        return{
            datanovisiblechat:0,
            datanovisiblechathistorial:0,
            modalchat:false,
            useractive: [],
            historialdata:[],
            message: '',
            identity: JSON.parse(localStorage.getItem('iden')),
            iduserchoosed:'',
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            tabactivechat:[
                {id:1,name:'user active',active:true},
                {id:2,name:'chat active',active:false},
                {id:3,name:'chat historial',active:false}
            ],
            datauserchoosed:null,
            message_data:[]

        }
    },
    sockets:{
        'getdatadeletemessage'(data){
            if(data){
                if(data._id_user_sender ===this.identity._id || data._id_user_sended ===this.identity._id){
                    if((data._id_user_sender ===this.identity._id || data._id_user_sended ===this.identity._id)&&(data._id_user_sender ===this.iduserchoosed || data._id_user_sended ===this.iduserchoosed)){
                        if(this.tabactivechat[1].active){if(this.tabactivechat[1].active){
                            this.getchat()
                        }
                        }
                    }
                }
            }

        },
        'getnewmessage'(data){
            if(data){
                if(data._id_user_sender ===this.identity._id || data._id_user_sended ===this.identity._id){
                    let datacountuser = [{
                        _id_user_sender : data._id_user_sender,
                        _id_user_sended : data._id_user_sended
                    }]
                    let checked = JSON.parse(localStorage.getItem('datacountuser'))
                    if(checked){
                        checked.push(datacountuser[0])
                        localStorage.setItem('datacountuser',JSON.stringify(checked))
                    }else{
                        localStorage.setItem('datacountuser',JSON.stringify(datacountuser))
                    }
                    this.gethistorialchat()
                    if(checked){
                        this.useractive.forEach(element=>{
                           element.count =  checked.filter(data=>String(data._id_user_sender)===String(element._id)||String(data._id_user_sended)===String(element._id)).length
                        })
                        this.getdatauseractive()
                    }
                    if(!this.modalchat){
                        this.datanovisiblechathistorial = this.datanovisiblechathistorial+1
                        localStorage.setItem('datanovisiblechat',this.datanovisiblechat)
                        if(!this.tabactivechat[2].active){
                            localStorage.setItem('datanovisiblechathistorial',this.datanovisiblechathistorial)
                            this.datanovisiblechat = this.datanovisiblechat+1
                            
                        }
                    }else{
                        if(!this.tabactivechat[2].active){
                            localStorage.setItem('datanovisiblechathistorial',this.datanovisiblechathistorial)
                            this.datanovisiblechat = this.datanovisiblechat+1
                        }
                        localStorage.setItem('datanovisiblechathistorial',this.datanovisiblechathistorial)
                        if((data._id_user_sender ===this.identity._id || data._id_user_sended ===this.identity._id)&&(data._id_user_sender ===this.iduserchoosed || data._id_user_sended ===this.iduserchoosed)){
                            if(this.tabactivechat[1].active){
                                this.getchat()
                                this.barScrollMessage()
                            }
                        }
                    }
                }
                //this.datanovisiblechat = this.datanovisiblechat+1
            }
        }
    },
    created(){
        //localStorage.removeItem('datacountuser')
        var checked=localStorage.getItem('datanovisiblechat')
        let checkedchathistorial = JSON.parse(localStorage.getItem('datanovisiblechathistorial'))
        //console.log(checked)
        if(checked!=null){
            this.datanovisiblechat = this.datanovisiblechat +  parseInt(checked)      
        }else{
            this.datanovisible = 0
        }
        if(checkedchathistorial){
            this.datanovisiblechathistorial = this.datanovisiblechathistorial +  parseInt(checkedchathistorial)
        }else{
            this.datanovisiblechathistorial = 0
        }
    },
    mounted(){
        if(this.language === 'English'){
            moment.locale('us')
        }else{
            moment.locale('es')
        }
        EventBus.$on('sendtohichat',(id)=>{
            this.modalchat = true
            this.openchatconversation(id)
        })
    },
    methods:{
        deletemessagechoosed(idmessage){
            let confirmcondition = confirm(this.language==='English'?'Do you want to delete this message?':'¿Deseas borrar este mensaje?')
            if(confirmcondition){
                let data = {
                    idusersender : JSON.parse(localStorage.getItem('iden'))._id,
                    idusersended: this.iduserchoosed,
                    idmessage:idmessage
                }
                this.$socket.emit('deletemessage',data)
            }
        },
        async seecontenthistorialchat(historialdata){
            try{
                let query={
                    idusersender : historialdata._id_user_sender._id,
                    idusersended : historialdata._id_user_sended._id
                }
                HistorialchatService.seecontenthistorialchat(query)
            }catch(err){
                console.log(err)
            }
        },
        async gethistorialchat(){
            try{
                const res = await HistorialchatService.gethistorialchat()
                let {data} = res
                this.historialdata = data.historial
                /*
                let checkedcountdata = JSON.parse(localStorage.getItem('datacountuser'))
                    if(checkedcountdata){
                        this.historialdata.forEach(element=>{
                            element.count =  checkedcountdata.filter(data=>String(data._id_user_sender)===String(element._id_user._id)||String(data._id_user_sended)===String(element._id_user._id)).length
                        })
                    }else{
                         this.historialdata.forEach(element=>{
                             element.count = 0
                         })
                    }*/
            }catch(err){
                console.log(err)
            }
        },
        openhistorialchat(){
            this.message_data=[]
            this.datanovisiblechathistorial = 0
            localStorage.removeItem('datanovisiblechathistorial')
            this.gethistorialchat()
            this.isTabActivechat(2)
        },
        savenewmessage(){
            let data = {
                idusersender : JSON.parse(localStorage.getItem('iden'))._id,
                idusersended: this.iduserchoosed,
                photo:JSON.parse(localStorage.getItem('user')).photo,
                fullname:JSON.parse(localStorage.getItem('user')).fullname,
                username: JSON.parse(localStorage.getItem('user')).username,
                message: this.message
            }
            this.$socket.emit('newmessage',data) 
            this.message = ''       
        },
        isTabActivechat:function(index){
            //console.log(index);
            this.tabactivechat.forEach(element=>{
                element.active=false;
            });
            this.tabactivechat[index].active=true;
        },
        openmodalchat(){
            this.modalchat = true
            this.datanovisiblechat = 0
            localStorage.removeItem('datanovisiblechat')
            this.getdatauseractive()
        },
        closemodalchat(){
            this.modalchat = false
        },
        openchatconversation(id){
            this.iduserchoosed = id
            let checkedcountdata = JSON.parse(localStorage.getItem('datacountuser'))
            if(checkedcountdata){
                let newdata = checkedcountdata.filter(data=>String(data._id_user_sended)!==String(id))
                if(newdata.length>0){
                    newdata = checkedcountdata.filter(data=>String(data._id_user_sender)!==String(id))
                }
                localStorage.setItem('datacountuser',JSON.stringify(newdata))
                this.getdatauseractive()
            }
            
            this.getdatauserchoosed()
            this.getchat()
            this.isTabActivechat(1)
        },
        openuseractivechat(){
            this.iduserchoosed = ''
            this.message_data = []
            this.getdatauserchoosed()
            this.isTabActivechat(0)
        },
        async getdatauserchoosed(){
            try{
                let query={
                    iduser:this.iduserchoosed
                }
                const res = await UsersService.getuserchoosedservice(query)
                let {data} = res
                this.datauserchoosed = data.data
                let userinactive = this.datauserchoosed.history[0].description === 'inactive'
                if(userinactive){
                    let date=moment(this.datauserchoosed.history[0].created_at).fromNow();
                    this.datauserchoosed.activedescription =  this.language==='English'?`Active ${date}`:`Activo ${date}`
                }else{
                    this.datauserchoosed.activedescription = this.language==='English'?`Active now`:`Activo ahora`
                }

            }catch(err){
                console.log(err)
            }
        },
        async getdatauseractive(){
            try{
                const res = await UsersService.getuseractive()
                if(res.data.userlimit.length>0){
                    this.useractive = res.data.userlimit
                    let checkedcountdata = JSON.parse(localStorage.getItem('datacountuser'))
                    if(checkedcountdata){
                        this.useractive.forEach(element=>{
                            element.count =  checkedcountdata.filter(data=>String(data._id_user_sender)===String(element._id)||String(data._id_user_sended)===String(element._id)).length
                        })
                    }else{
                         this.useractive.forEach(element=>{
                             element.count = 0
                         })
                    }
                }else{
                    this.useractive = []
                }
                

            }catch(err){
                console.log(err)
            }
        },
        async getchat(){
            try{
                let query = {
                    idusersender: JSON.parse(localStorage.getItem('iden'))._id,
                    idusersended: this.iduserchoosed
                }
                const res = await ChatsimpleService.getchat(query)
                let {data}=res
                this.message_data = data.chats
            }catch(err){
                console.log(err)
                this.message_data = []
            }
        },
        barScrollMessage:function(){
            setTimeout(function(){
                var scroll=document.getElementById('messages_content');
                scroll.scrollTop=scroll.scrollHeight;
            },10)  
        }
    }
}
</script>
<style lang="scss" scoped>
    .chat-button {
        position: fixed;
        background: #007bff;
        width: 44px;
        height: 44px;
        text-align: center;
        line-height: 2;
        font-size: 16px;
        border-radius: 50%;
        left: 15px;
        bottom: 15px;
        font-size:22px;
        z-index: 100000;
    }
    
</style>